import Icon from 'components/Icon'
import { EditIcon } from 'components/Icon/icons/edit'
import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'

function EditButton ({ url, size }) {
  const to = url + '/edit'
  return (
    <Link to={to}>
      <Icon
        icon={EditIcon}
        size={size}
      />
    </Link>
  )
}

EditButton.SIZE = Icon.SIZE

EditButton.propTypes = {
  url: PropTypes.string.isRequired
}

export default EditButton
